import TopBar from '../../components/feature/TopBar';
import Navbar from '../../components/feature/Navbar';
import HeroSection from './components/HeroSection';
import WarningSection from './components/WarningSection';
import ServicesGrid from './components/ServicesGrid';
import ServiceDetailSection from './components/ServiceDetailSection';
import HowItWorks from './components/HowItWorks';
import PricingSection from './components/PricingSection';
import UrgencySection from './components/UrgencySection';
import Reviews from './components/Reviews';
import BeforeAfterSection from './components/BeforeAfterSection';
import FAQ from './components/FAQ';
import AppointmentForm from './components/AppointmentForm';
import StickyMobileBar from './components/StickyMobileBar';
import Footer from './components/Footer';
import { services } from '../../mocks/servicesData';
import { PHONE_1 } from '../../components/feature/TopBar';

const WA_FLOAT = `https://wa.me/90${PHONE_1}?text=${encodeURIComponent('Merhaba, profesyonel temizlik hizmeti hakkında bilgi almak istiyorum.')}`;

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white font-sans pb-16 md:pb-0">
      {/* Top announcement bar */}
      <TopBar />

      {/* Main navigation */}
      <Navbar />

      {/* 1. Hero */}
      <HeroSection />

      {/* 2. Warning / Attention grabber */}
      <WarningSection />

      {/* 3. Services Grid */}
      <ServicesGrid />

      {/* 4. Service Details (all 4) */}
      {services.map((service, i) => (
        <ServiceDetailSection key={service.id} service={service} index={i} />
      ))}

      {/* 5. How It Works */}
      <PricingSection />
      <UrgencySection />
      <HowItWorks />

      {/* 6. Customer Reviews */}
      <BeforeAfterSection />
      <Reviews />

      {/* 7. FAQ */}
      <FAQ />

      {/* 8. Appointment Form */}
      <AppointmentForm />

      {/* Footer */}
      <Footer />

      {/* WhatsApp Floating Button (Desktop) */}
      <a
        href={WA_FLOAT}
        target="_blank"
        rel="nofollow noreferrer"
        className="hidden md:flex fixed bottom-8 right-8 z-50 w-14 h-14 items-center justify-center bg-[#25D366] hover:bg-[#20b858] rounded-full shadow-lg shadow-green-500/30 transition-all hover:scale-110 group"
        title="WhatsApp ile Mesaj Gönder"
      >
        <i className="ri-whatsapp-line text-white text-2xl" />
        <span className="absolute right-16 bg-[#1a1a1a] text-white text-xs font-semibold px-3 py-1.5 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
          Hemen Mesaj Gönder
        </span>
      </a>

      {/* Sticky Mobile Bottom Bar */}
      <StickyMobileBar />
    </div>
  );
}
